import { useCallback } from 'react';
import { PopoverPosition } from '../types';

interface UseButtonClickProps {
  isMobile: boolean;
  activeHover: boolean;
  isOpen: boolean;
  handleOpen: (newState: boolean) => void;
  setCurrentPosition: (position: PopoverPosition) => void;
  calculatePosition: () => PopoverPosition;
}

export function useButtonClick({
  isMobile,
  activeHover,
  isOpen,
  handleOpen,
  setCurrentPosition,
  calculatePosition,
}: UseButtonClickProps) {
  return useCallback(() => {
    if (isMobile && activeHover) {
      // For mobile tooltips, always allow toggle on click
      handleOpen(!isOpen);
      if (!isOpen) {
        const calculatedPosition = calculatePosition();
        setCurrentPosition(calculatedPosition);
      }
    } else {
      // Normal behavior for everything else
      handleOpen(!isOpen);
    }
  }, [
    isMobile,
    activeHover,
    isOpen,
    handleOpen,
    calculatePosition,
    setCurrentPosition,
  ]);
}
